import ajax from '@/utils/request'
import config from '@/config'
import state from '../store/state'

export default {
  /**
   * 获取活动管理信息
   * @param {String} id ID
   * @param {String} title 标题
   * @param {Number} start_time 活动开始时间
   * @param {Number} end_time 活动结束时间
   * @param {String} remark 备注
   * @param {Number} type 0 线上, 1 线下
   * @param {Object} address json: province city address
   * @param {Number} map_type 0 不展示, 1 展示
   * @param {Array} map_data []逗号隔开经纬度
   * @param {String} banner 头图
   */
  getEventInfo (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/activity/getInfo',
      data: data
    })
  },
  getFormInfo (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/form/getInfo',
      data: data
    })
  },
  /**
   * https://yapi.geekbang.org/project/170/interface/api/8059
   *
   */
  getFormQuestion (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/form/getQuestion',
      data: data
    })
  },
  getEnterpriseUserFieldsValue (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/misc/fields'
    }).then(data => {
        return data?.list?.reduce((map, ele) => {
          const { type, values } = ele
          map[type] = values
          return map
          }, {})
    })
  },
  submitForm (data, extra) {
    return ajax({
      type: 'post',
      host: state.loginDomain === 'biz'
        ? '//b.geekbang.org/'
        : config.baseHost,
      url: 'activity/v2/form/submit',
      data,
      signin: extra.needLogin,
      extra,
      headers: state.loginDomain === 'biz'
        ? { 'Es-Type': 'es' }
        : {}
    })
  },
  getPrivewInfo (url) {
    // 测试打包使用 测试CDN
    // let url = 'https://static001-test.infoq.cn/resource/form/preview/formpreview.json'

    // if (process.env.NODE_ENV === 'production') {
    //   // 生产环境打包使用线上cdn
    //   if (process.env.BUILD_ENV === 'prod') {
    //     url = 'https://static001.infoq.cn/resource/form/preview/formpreview.json'
    //   }
    // }
    let time = new Date().getTime()
    return ajax({
      withCredentials: false,
      type: 'get',
      url: `${url}?time=${time}`
    })
  },
  /**
   * @see https://yapi.geekbang.org/project/170/interface/api/19623
   */
  uploadFile (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/resource/upload',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteFile (data) {
    return ajax({
      type: 'post',
      url: 'activity/v2/resource/delete',
      data
    })
  },
  /**
   * 发送验证码
   * https://yapi.geekbang.org/project/170/interface/api/20152
   * @param {*} country 国家区号
   * @param {*} cellphone 手机号
   * @param {*} data 滑块数据
   * @param {*} type 企业签名
   * @returns
   */
  sendCode (country, cellphone, data, type) {
    const postData = {
      country,
      cellphone,
      data: data || window.getNVCVal(),
      type
    }
    return ajax({
      url: 'activity/v2/verify/sendCaptch',
      data: postData
    })
  }
}
